import { render, staticRenderFns } from "./ReportCardTemplate.vue?vue&type=template&id=49a07a4f&scoped=true&"
import script from "./ReportCardTemplate.vue?vue&type=script&lang=ts&"
export * from "./ReportCardTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./ReportCardTemplate.vue?vue&type=style&index=0&id=49a07a4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a07a4f",
  null
  
)

export default component.exports